export default __webpack_public_path__ + "static/media/Icon_Create_Invoice.de8d1964.svg";